import * as React from 'react';
import useTranslation from '../../../../../translation/hooks/UseTranslation';
var TextImplementation = function (textProps) {
    var t = useTranslation().t;
    if (textProps.link) {
        return (React.createElement("a", { href: textProps.link, target: textProps.linkTargetSamePage ? '_self' : '_blank', className: textProps.className }, textProps.noTranslation ? textProps.children : t(textProps.children)));
    }
    return (React.createElement("span", { className: textProps.className }, textProps.noTranslation ? textProps.children : t(textProps.children)));
};
export default TextImplementation;
//# sourceMappingURL=TextImplementation.js.map